import { useDefaultModuleActions } from "../../common"
import { useDataTypeFileActions } from "../../../features/data-types"
import { DynamoUserApi } from "../../../services"
import { DataType, TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { Company, useSystemActions, useSystemStateHooks } from "../../system"
import { CreditCard, Settings } from "../state/types"

export const useAdministrationActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const defaultModuleActions = useDefaultModuleActions()
    const systemActions = useSystemActions()
    const dataTypeFileActions = useDataTypeFileActions()

    return (paramCompanyId?: string) => {
        const companyId = paramCompanyId || stateCompanyId
        const { save, remove } = defaultModuleActions(DynamoUserApi, define(companyId))

        const saveSettings = (settings: Settings) => {
            return save(TableName.SETTINGS, settings)
        }

        const saveCompany = (company: Company) => {
            return systemActions().saveCompany(company)
        }
        
        const saveCreditCard = (creditCard: CreditCard) => {
            return save(TableName.CREDIT_CARDS, creditCard)
        }

        const removeCreditCard = (id: string) => {
            return remove(TableName.CREDIT_CARDS, id)
        }

        const removePaymentOrder = (id: string) => {
            const { removeWithFile } = dataTypeFileActions(define(companyId))
            return removeWithFile(TableName.PAYMENT_ORDERS, id, 'receiptUrl' as keyof DataType)
        }

        return {
            saveSettings,
            saveCompany,
            saveCreditCard,
            removeCreditCard,
            removePaymentOrder
        }
    }
}
